import { webLightTheme, webDarkTheme, makeStyles, themeToTokensObject } from "@fluentui/react-components";

// There is no nice way to handle the theme in the OfficeJS environment.
// The theme is not passed as a prop, but is available in the Office context as the bodyBackgroundColor.
const ThemeColors = {
  LIGHT: "#FAF9F8",
  DARK: "#212121",
};

const customSpacing = {
  spacingVerticalPageHeader: "52px",
};

export const customWebLightTheme = {
  ...webLightTheme,
  ...customSpacing,
  colorSectionHeaderBackground: "#F6F8FA" 
};

export const customWebDarkTheme = {
  ...webDarkTheme,
  ...customSpacing,
  colorSectionHeaderBackground: "#3B3B3B"
};

export const applyTheme = (officeTheme) => {
  const { bodyBackgroundColor } = officeTheme;
  
  if (bodyBackgroundColor === ThemeColors.LIGHT) {
    return customWebLightTheme;
  } else if (bodyBackgroundColor === ThemeColors.DARK) {
    return customWebDarkTheme;
  }

  return customWebLightTheme;
};

export const themeTokens = themeToTokensObject(customWebLightTheme);

export const useGlobalStyles = makeStyles({
  truncateText: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
});
